<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <v-container>
            <v-row>
                <v-col xs="12">
                    <v-progress-linear v-if="waiting" class="mb-2" :indeterminate="true"/>
                    <v-subheader>
                        <span>Subscription</span>
                    </v-subheader>
                    <v-form ref="form">
                        <v-container>
                            <v-card-text class="d-flex flex-wrap font-weight-black">
                                {{`Current Plan: ${paymentInfo.subscriptions ? paymentInfo.subscriptions[0].name : 'None'}`}}
                            </v-card-text>
                            <v-card-text class="mt-n6 d-flex flex-wrap font-weight-black">
                                {{`${paymentInfo.subscriptions && paymentInfo.subscriptions[0].canceledDate ? 'Subscription Ends' : 'Next Billing'}: ${paymentInfo.subscriptions ? new Date(paymentInfo.subscriptions[0].currentPeriodEnd).toLocaleString().split((','))[0] : "N/A"}`}}
                            </v-card-text>
                            <v-row class="ma-2">
                                <v-btn small color="yellow" depressed @click="cancelPaymentPlan = true" :disabled="!paymentInfo.subscriptions || paymentInfo.subscriptions.canceledDate != null">
                                    <v-icon left>mdi-cancel</v-icon>
                                    Cancel
                                </v-btn>
                            </v-row>
                        </v-container>
                    </v-form>
                    <v-subheader>
                        <span>Cards</span>
                        <v-spacer/>
                        <v-btn small color="yellow" depressed @click="addCreditCard = true">
                            <v-icon left>mdi-credit-card-plus</v-icon>
                            Add
                        </v-btn>
                    </v-subheader>
                    <v-form ref="form">
                        <v-list>
                            <template v-for="(card, cardIndex) in paymentInfo.cards">
                                <template v-if="card.brand">
                                    <v-container>
                                        <v-row>
                                            <v-col xs="12">
                                                <v-card :class="{'mt-n8' : cardIndex !== 0}" flat outlined>
                                                    <template v-if="card.defaultCard">
                                                        <v-container>
                                                            <v-row>
                                                                <v-card flat class="mb-n6">
                                                                    <v-chip class="ml-2" color="blue lighten-3" x-small text-color="deep-purple">Default</v-chip>
                                                                </v-card>
                                                            </v-row>
                                                        </v-container>
                                                    </template>
                                                    <v-card-actions>
                                                        <v-avatar>
                                                            <v-img width="64" height="36" :src="require(`@/assets/images/${card.brand.toLowerCase()}.svg`)"/>
                                                        </v-avatar>
                                                        <span class="ma-2">{{`•••• ${card.last4}`}}</span><span class="ma-2">{{`${String(card.expMonth).padStart(2, '0')}/${card.expYear}`}}</span>
                                                        <v-spacer/>
                                                        <v-menu bottom right offset-y>
                                                            <template v-slot:activator="{on}">
                                                                <v-btn depressed v-on="on">
                                                                    <v-icon>mdi-dots-horizontal</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <v-list>
                                                                <v-list-item v-for="(command, commandIndex) in commands" :disabled="(paymentInfo.cards.length < 2 && commandIndex === 1) || (card.defaultCard && commandIndex === 2)" @click="command.action(commandIndex, cardIndex)">
                                                                    <v-list-item-icon>
                                                                        <v-icon v-text="command.icon"></v-icon>
                                                                    </v-list-item-icon>
                                                                    <v-list-item-title>{{command.title}}</v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-menu>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </template>
                            </template>
                        </v-list>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
        <AddCreditCardDialog v-if="addCreditCard" :forOrg="orgData.id" @add-credit-card-dialog-response="cardAddedResponse"></AddCreditCardDialog>
        <EditCreditCardDialog v-if="editCreditCard" :forOrg="orgData.id" :cardIndex="currentCardIndex" @edit-credit-card-dialog-response="cardEditResponse"></EditCreditCardDialog>
        <RemoveCreditCardDialog v-if="removeCreditCard" :forOrg="orgData.id" :cardIndex="currentCardIndex" @remove-credit-card-dialog-response="cardRemoveResponse"></RemoveCreditCardDialog>
        <CancelPaymentPlanDialog v-if="cancelPaymentPlan" :forOrg="orgData.id" @cancel-payment-plan-dialog-response="cancelPaymentPlanResponse"></CancelPaymentPlanDialog>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import AddCreditCardDialog from '@/components/add-credit-card-dialog'
    import EditCreditCardDialog from '@/components/edit-credit-card-dialog'
    import RemoveCreditCardDialog from '@/components/remove-credit-card-dialog'
    import CancelPaymentPlanDialog from '@/components/cancel-payment-plan-dialog'

    export default {
        name: 'org-payment-plan-info-dialog',
        components:
        {
            AddCreditCardDialog,
            EditCreditCardDialog,
            RemoveCreditCardDialog,
            CancelPaymentPlanDialog
        },
        data: function ()
        {
            return {
                currentCardIndex: 0,
                commands:
                [
                    {
                        title: 'Edit',
                        icon: 'mdi-credit-card-settings',
                        action: this.commandSelected
                    },
                    {
                        title: 'Remove',
                        icon: 'mdi-credit-card-off',
                        action: this.commandSelected
                    },
                    {
                        title: 'Set as Default',
                        icon: 'mdi-credit-card-marker',
                        action: this.commandSelected
                    }
                ],
                addCreditCard: false,
                editCreditCard: false,
                removeCreditCard: false,
                cancelPaymentPlan: false
            }
        },
        props:
        {
            dialog: false,
            editedIndex: 0,
            orgData: {}
        },
        computed:
        {
            ...mapState('orgs',
            {
                orgs: state => state.orgs
            }),
            ...mapState('customerBilling',
            {
                paymentInfo: state => state.paymentInfo,
                serverError: state => state.error
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            })
        },
        methods:
        {
            ...mapMutations('customerBilling', ['CLEAR_ERROR']),
            ...mapActions('customerBilling', ['GET_ORG_PAYMENT_INFO', 'SET_ORG_PAYMENT_INFO']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            async commandSelected(commandIndex, cardIndex)
            {
                this.currentCardIndex = cardIndex;
                // If the edit command was selected
                if (0 === commandIndex)
                {
                    this.editCreditCard = true
                }
                // If the remove command was selected
                else if (1 === commandIndex)
                {
                    this.removeCreditCard = true
                }
                else // Else the set as default command was selected
                {
                    try
                    {
                        this.HIDE_SNACKBAR();
                        this.WAITING(true);
                        this.paymentInfo.cards[cardIndex].defaultCard = true;
                        await this.SET_ORG_PAYMENT_INFO({orgId: this.orgData.id, data: this.paymentInfo});
                        this.WAITING(false)
                    }
                    catch (error)
                    {
                        this.SHOW_SNACKBAR_ERROR(error.message);
                        this.WAITING(false);
                        await this.getPaymentInfo()
                    }
                }
            },
            async cardAddedResponse(payload)
            {
                this.addCreditCard = false;
                if (payload)
                {
                    await this.getPaymentInfo()
                }
            },
            async cardEditResponse(payload)
            {
                this.editCreditCard = false;
                if (payload)
                {
                    await this.getPaymentInfo()
                }
            },
            async cardRemoveResponse(payload)
            {
                this.removeCreditCard = false;
                if (payload)
                {
                    await this.getPaymentInfo()
                }
            },
            async cancelPaymentPlanResponse(payload)
            {
                this.cancelPaymentPlan = false;
                if (payload)
                {
                    await this.getPaymentInfo()
                }
            },
            async getPaymentInfo()
            {
                try
                {
                    await this.GET_ORG_PAYMENT_INFO(this.orgData.id)
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.response && error.response.data && error.response.data.reason ? error.response.data.reason : error.message)
                }
                this.WAITING(false)
            }
        }
    }
</script>

<style lang="scss" scoped>
    form
    {
        border-width: 2px;
        border-style: solid;
        border-color: #000000;
    }

    .break {
        flex: 1 1 aut;
        height: 0;
    }
</style>